export default "__VITE_ASSET__BJvnbztj__"